// Прямой вызов API: Next.js rewrites не передают Authorization в бэкенд, поэтому в браузере тоже используем прямой URL.
export { api, ApiClient } from './client';
export { ApiError, API_URL, buildQueryString, resolveWebAdminApiBaseUrl } from './http/core';
export { buildChatAttachmentPreviewUrl, fileUrlWithAccessToken } from './urls';
